<template>
  <div class="salesmandailizhongxingPage">
      <div class="login-bg" v-if="projectName != 'xurigo'" :style="{  backgroundImage:'url('+siteConfig.MobileBgImage+')' }">
         <mu-flat-button label="提现" to="/usercenter/coinWithdraw" class="demo-flat-button"/>
          <img class="touxiang" :src="headPic" alt="">
          <div class="bouns">  
            <div class="grant">
                <p class="count">{{awardInfo.daySy.toFixed(2)}}</p>
                <p class="text">今日发放</p>
            </div>          
            <div class="put">
                <p class="count">{{awardInfo.tx.toFixed(2)}}</p>
                <p class="text">可提金额</p>
            </div>   
            <!-- <div class="zichanBg">
              <img style="width: 100%;display: block;" src=" ../static/us-zichan.png" alt="">
            </div> -->
          </div>
      </div>
      <div class="login-bg" v-if="projectName == 'xurigo'" :style="{  backgroundImage:'url('+siteConfig.MobileBgImage+')' }">
          <mu-flat-button label="提现" to="/usercenter/coinWithdraw" class="demo-flat-button"/>
           <img class="touxiang" :src="headPic" alt="">
           <p class="memberLv">
              <span v-if="nickName" class="nickName">{{nickName}}</span>
              <a v-else href="/#/usercenter/person"><span class="nickName" >请完善资料</span></a>
              <span class="level"><i class="fa fa-diamonds icon"></i>{{agent}}</span>
            </p>         
            <p class="inviteCode">
              <span>邀请码：{{showName}}</span>
              <span class="copyBtn" @click="copyCode">复制</span>
            </p>
           <div class="bouns">  
             <div class="grant">
                 <p class="count">{{awardInfo.daySy.toFixed(2)}}</p>
                 <p class="text">今日发放</p>
             </div>          
             <div class="put">
                 <p class="count">{{awardInfo.tx.toFixed(2)}}</p>
                 <p class="text">可提金额</p>
             </div>   
             <!-- <div class="zichanBg">
               <img style="width: 100%;display: block;" src=" ../static/us-zichan.png" alt="">
             </div> -->
           </div>
       </div>
      <mu-list-item class="extension" title="推广得佣金">
        <mu-icon size="20" color="#fff" slot="left" value=":fa fa-laba"/>
        <mu-icon slot="right" value=":fa fa-angle-right"/>
      </mu-list-item>
      <mu-list>
          <div class="achievement-head" >
            <img src="static/1221.png" alt="">
              推广业绩
          </div>          
         <div class="achievement-row">
            <router-link to="/salesman/mymember" v-if="indexInfo.UserBs==4 ||indexInfo.UserBs==6 ||indexInfo.UserBs==7||indexInfo.UserBs==8">
              <mu-list-item class="achievement-content">
                <div>
                  <div v-if="indexInfo.MyMemberNum>0"><div class="mu-avatar-inner">{{indexInfo.MyMemberNum}}</div></div>
                  <mu-icon value=":fa fa-member2"/>
                  <p>我的会员</p>
                </div> 
              </mu-list-item>
            </router-link>
            <router-link to="/salesman/mytuijian" v-if="indexInfo.UserBs>0">
              <mu-list-item class="achievement-content">
                <div>
                  <div v-if="indexInfo.MyTjMemberNum>0"><div class="mu-avatar-inner">{{indexInfo.MyTjMemberNum}}</div></div>
                  <mu-icon value=":fa fa-people3"/>
                  <p>我的推荐</p>
                </div> 
              </mu-list-item>
            </router-link>
            <router-link to="/salesman/mydaili" v-if="indexInfo.UserBs==6 ||indexInfo.UserBs==7||indexInfo.UserBs==8">
              <mu-list-item class="achievement-content">
                <div>
                  <div v-if="indexInfo.MyProxyNum>0"><div class="mu-avatar-inner">{{indexInfo.MyProxyNum}}</div></div>
                  <mu-icon value=":fa fa-money4"/>
                  <p>我的代理</p>
                </div> 
              </mu-list-item>
            </router-link>
            <router-link to="/salesman/myzhaoshang">
              <mu-list-item class="achievement-content">
                <div>
                  <div v-if="indexInfo.MyCanvassNum>0"><div class="mu-avatar-inner">{{indexInfo.MyCanvassNum}}</div></div>
                  <mu-icon value=":fa fa-brand"/>
                  <p>我的招商</p>
                </div> 
              </mu-list-item>
            </router-link>
         </div>
      </mu-list>
      <mu-list>
        
          <div class="achievement-head" >
            <img src="static/1221.png" alt="">
              推广工具
          </div>
         <div class="tool-row">
            <router-link to="/salesman/myCard" >
              <mu-list-item class="tool-content">
                <div>
                  <mu-icon value=":fa fa-people"/>
                  <p>我的名片</p>
                </div> 
              </mu-list-item>
            </router-link>
            <router-link to="/salesman/tuiguang" v-if="indexInfo.UserBs>1">
              <mu-list-item class="tool-content">
                <div>
                  <mu-icon value=":fa fa-people"/>
                  <p>我要推广</p>
                </div> 
              </mu-list-item>
            </router-link>
            <router-link to="/salesman/setting" >
              <mu-list-item class="tool-content">
                <div>
                  <mu-icon value=":fa fa-money4"/>
                  <p>店铺设置</p>
                </div> 
              </mu-list-item>
            </router-link>
            <router-link to="/salesman/fenxiang">
              <mu-list-item class="tool-content">
                <div>
                  <mu-icon value=":fa fa-brand"/>
                  <p>分享设置</p>
                </div> 
              </mu-list-item>
            </router-link>
         </div>
      </mu-list>
       <!-- <mu-list v-if="false">
         <div class="achievement-head" >
           <img src="static/1221.png" alt="">
              代理操作
          </div>
         <div class="operation-row">
            <router-link to="/wholesale/index" >
              <mu-list-item class="operation-content">               
                <div>
                  <img src="https://frontend.xurigo.com/icon/new.gif" class="new">
                  <mu-icon value=":fa fa-house3"/>
                  <p>我要批发</p>
                </div> 
              </mu-list-item>
            </router-link>
            <router-link to="/salesman/registerMember" v-if="(indexInfo.UserBs==4 ||indexInfo.UserBs==6 ||indexInfo.UserBs==7||indexInfo.UserBs==8)&&indexInfo.isRegMember">
              <mu-list-item class="operation-content">
                <div>
                  <mu-icon value=":fa fa-user-plus"/>
                  <p>注册创客</p>
                </div> 
              </mu-list-item>
            </router-link>
            <router-link  to="/salesman/fenliustore" v-if="indexInfo.UserBs==4 ||indexInfo.UserBs==6 ||indexInfo.UserBs==7||indexInfo.UserBs==8" >
              <mu-list-item class="operation-content">
                <div>
                  <mu-icon value=":fa fa-share2"/>
                  <p>分流创客</p>
                </div> 
              </mu-list-item>
            </router-link>
            <router-link to="/salesman/fenliuserver" v-if="indexInfo.UserBs==6 ||indexInfo.UserBs==7||indexInfo.UserBs==8">
              <mu-list-item class="operation-content">
                <div>
                  <mu-icon value=":fa fa-meeting"/>
                  <p>分流服务商</p>
                </div> 
              </mu-list-item>
            </router-link>
            <router-link to="/salesman/purchaseorderlist">
              <mu-list-item class="operation-content">
                <div>
                  <div v-if="indexInfo.MyPurchaseOrderNum>0"><div class="mu-avatar-inner">{{indexInfo.MyPurchaseOrderNum}}</div></div>
                  <mu-icon value=":fa fa-shop-member"/>
                  <p>批发订单</p>
                </div> 
              </mu-list-item>
            </router-link>
            <router-link  to="/wholesale/cart"  v-if="indexInfo.UserBs>1">
              <mu-list-item class="operation-content">
                <div>
                  <mu-icon value=":fa fa-gouwucar"/>
                  <p>批发购物车</p>
                </div> 
              </mu-list-item>
            </router-link>
            <router-link to="/salesman/mydingdan" v-if="indexInfo.UserBs==4 ||indexInfo.UserBs==6 ||indexInfo.UserBs==7 || indexInfo.UserBs==8">
              <mu-list-item class="operation-content">
                <div>
                  <div v-if="indexInfo.ShopOrderTotal.TotalCount>0"><div class="mu-avatar-inner">{{indexInfo.ShopOrderTotal.TotalCount}}</div></div>
                  <mu-icon value=":fa fa-order2"/>
                  <p>店铺订单</p>
                </div> 
              </mu-list-item>
            </router-link>
            <router-link to="/salesman/viporderlist" v-if="indexInfo.UserBs==1 && isBuHuoConfig">
              <mu-list-item class="operation-content">
                <div>
                  <mu-icon value=":fa fa-text"/>
                  <p>加盟订单</p>
                </div> 
              </mu-list-item>
            </router-link>
         </div>
      </mu-list> -->
      <mu-list>
          <div class="achievement-head" >
            <img src="static/1221.png" alt="">
              代理账户
          </div>
         <div class="account-row">
            <router-link to="/salesman/mybonus" >
              <mu-list-item class="account-content">
                <div>
                  <mu-icon value=":fa fa-money"/>
                  <p>我的奖金</p>
                </div> 
              </mu-list-item>
            </router-link>
            <!-- <router-link to="/salesman/purchaseCoin" v-if="indexInfo.UserBs>1">
              <mu-list-item class="account-content">
                <div>
                  <mu-icon value=":fa fa-money"/>
                  <p>我的配货额</p>
                </div> 
              </mu-list-item>
            </router-link> -->
         </div>
      </mu-list>



      <XR-bottom ref="XRbottom"></XR-bottom>
      <XR-toast ref="XRtoast"></XR-toast>
      <mu-dialog :open="dialog" title="领取大礼包" @close="close">
        您有一个大礼包未领取
        <mu-flat-button slot="actions" @click="close" primary label="取消"/>
        <mu-flat-button slot="actions" primary @click="getGift" label="领取"/>
      </mu-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loaded:true,
      nickName:'',
      showName: '',
      agent:'创客',
      indexInfo:{
        isRegMember:false,
        MyPurchaseOrderNum:0,
        MyMemberNum:0,
        MyTjMemberNum:0,
        ShopOrderTotal:{
          GetCount:0,
          TotalCount:0,
          TotalMoney:0,
          UnGetCount:0
        },
        MyProxyNum:0
      },
      awardInfo:{
        sr:0.00,
        daySy:0.00,
        tx:0.00
      },
      headPic:'http://frontend.xurigo.com/icon/person.jpg' ,
      dialog: false,
      cookieKey:'__XR_salesman_tip_notice',
      isBuHuoConfig:false,//补货配置
      isBuHuo: false,
      isShowVipUpgradeOrder:false,
      siteConfig:{ MobileBgImage : '' }
    }
  },
  methods: {
    
  },
  mounted(){
    if (!this.$store.state.user.SessionId) {
      this.$router.push("/Login")
      return;
    }
    this.getSiteInfo()
    this.getIndexInfo()
    this.getArawdInfo()
    this.getSalesmanInfo()
  },
  methods: {
    getSiteInfo: function () {    
        const ths = this;
        this.$post('/Shop/SiteConfigServer/GetSiteConfig')
            .then(function (res) {
            if(res.IsSuccess){
                ths.siteConfig = res.Data
            }         
        })
        .catch(function (err) {
            console.log(err)
        })    
    },
    copyCode(){
        const input = document.createElement('input');
        input.setAttribute('readonly', 'readonly');
        input.setAttribute('value', this.showName);
        document.body.appendChild(input);
            input.select()
            if (document.execCommand('copy')) {
                document.execCommand('copy');
                this.$refs.XRtoast.success('复制成功',true)  
            }
        document.body.removeChild(input);
    },
    getSalesmanInfo(){      
      const ths = this;
      this.$post("/Shop/UserServer/GetUserInfo")
      .then(function(res) {
        if (res.IsSuccess) {
            ths.nickName = res.Data.NickName
            ths.agent = res.Data.UserBsName
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    getIndexInfo(){      
      const ths = this;
      this.$post("/Salesman/SalesmanServer/GetSalesmanIndexInfo")
      .then(function(res) {
        if (res.IsSuccess) {          
          ths.indexInfo = res.Data
          ths.cookieKey = ths.cookieKey + res.Data.minnerbm
          if(res.Data.HeadPic){            
            ths.headPic = res.Data.HeadPic
          }
          ths.showName = res.Data.UserName
          if(ths.indexInfo.UserBs == 0){
            ths.$router.push('/usercenter/openSalesman')
          }
          else if(ths.indexInfo.UserBs == 1){
            ths.GetBuHuoConfig()
          }else{            
            ths.loaded = false;
            ths.$refs.XRtoast.hide();
          }
		  if(res.Data.saleMenCategory){
			var saleMenCategory = new Array();
			for (var i=0;i<res.Data.saleMenCategory.length;i++){
				saleMenCategory[res.Data.saleMenCategory[i].cid] = res.Data.saleMenCategory[i].catename;
				window.localStorage.setItem("saleMenCategory", saleMenCategory);
			}
		  }
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    GetBuHuoConfig(){
      var ths = this;
      ths.$post("/Salesman/SalesmanServer/GetBuHuoConfig")
        .then(function (res) {
          ths.isBuHuoConfig = res.IsSuccess
          if(ths.isBuHuoConfig){
            ths.getBuHuoInfo()
          }
        })
    },
    getBuHuoInfo(){  
      const ths = this;
      this.$post("/Salesman/SalesmanServer/GetBuHuoInfo")
      .then(function(res) {
        ths.loaded =false
        ths.$refs.XRtoast.hide();
        if (res.IsSuccess) {  
          ths.isBuHuo = true
          ths.isShowVipUpgradeOrder = true
          //判断补货情况
          //1、先读取缓存，看看是否需要提示
          var getCookie = document.cookie.replace(/[ ]/g,"");  //获取cookie，并且将获得的cookie格式化，去掉空格字符
          var arrCookie = getCookie.split(";")  //将获得的cookie以"分号"为标识 将cookie保存到arrCookie的数组中
          var tips;  //声明变量tips
          for(var i=0;i<arrCookie.length;i++){   //使用for循环查找cookie中的tips变量
            var arr=arrCookie[i].split("=");   //将单条cookie用"等号"为标识，将单条cookie保存为arr数组
            if(ths.cookieKey==arr[0]){  //匹配变量名称，其中arr[0]是指的cookie名称，如果该条变量为tips则执行判断语句中的赋值操作
              tips=arr[1];   //将cookie的值赋给变量tips
              break;   //终止for循环遍历
            }
          }
          if(tips){
            return
          }      
          ths.open()
        }else{
          if(res.TypeId != 1){
            ths.isShowVipUpgradeOrder = true
          }
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    getArawdInfo(){      
      const ths = this;
      this.$post("/Salesman/SalesmanServer/GetShopGoldCount")
      .then(function(res) {
        if (res.IsSuccess) {          
          ths.awardInfo = res.Data
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    open () {
      this.dialog = true
    },
    close () {
      var date=new Date(); //获取当前时间
      date.setTime(date.getTime()+ 7*24*3600*1000); //格式化为cookie识别的时间
      document.cookie= this.cookieKey + "=" + 1 +";expires="+date.toGMTString();  //设置cookie      

      this.dialog = false
    },
    getGift(){
      this.$router.push('/salesman/giftAddress')
    }
  }
}
</script>
<style>
body .salesmandailizhongxingPage{
    background: #eee;
    padding-bottom:56px;
}
.salesmandailizhongxingPage .zichanBg{
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 0;
}
.salesmandailizhongxingPage .extension{
  background: #fff;
}
.salesmandailizhongxingPage .extension .show-left{
  padding-left: 70px;
}
.salesmandailizhongxingPage .extension .show-left .mu-item-left{
  background: url('/static/BAW/duihuan.png');
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin-top: 6px;
}
.salesmandailizhongxingPage .extension .show-left .mu-item-title{
  font-size: 14px;
}
.salesmandailizhongxingPage .mu-list{
  background: #fff;
  margin-top: 10px;
  padding: 0;
}
.salesmandailizhongxingPage .mu-list .achievement-head{
  border-bottom: 1px solid #f5f5f5;
  font-size: 14px;
  font-weight: bold;
  padding: 16px;
}
.salesmandailizhongxingPage .mu-list .mu-item-content p{
  font-size: 12px;
  line-height: 14px;
  height: 28px;
}
.salesmandailizhongxingPage .mu-list .achievement-row .achievement-content{
  text-align: center;
  float: left;
  width: 25%;
}
.salesmandailizhongxingPage .mu-list .mu-item-content .mu-icon{
  color: #757575;
  font-size: 20px;
}
.salesmandailizhongxingPage .mu-list .tool-row .tool-content{
  text-align: center;
  float: left;
  width: 25%;
}
.salesmandailizhongxingPage .mu-list .tool-row .tool-content .mu-icon{
  color: #757575;
  font-size: 20px;
}
.salesmandailizhongxingPage .mu-list .operation-row .operation-content{
  text-align: center;
  float: left;
  width: 25%;
}
.salesmandailizhongxingPage .mu-list .operation-row .operation-content .mu-icon{
  color: #757575;
  font-size: 20px;
}
.salesmandailizhongxingPage .mu-list .account-row .account-content{
  text-align: center;
  float: left;
  width: 25%;
}
.salesmandailizhongxingPage .mu-list .account-row .account-content .mu-icon{
  color: #757575;
  font-size: 20px;
}
.salesmandailizhongxingPage .mu-item-content{
  display: flex;
  justify-content: center;
}
.salesmandailizhongxingPage .mu-item-content>div{
  position: relative;
}
.salesmandailizhongxingPage .mu-item-left .fa{
  font-size: 24px;
  width: auto;
}

.salesmandailizhongxingPage .mu-item-title{
  font-size: 16px;
  position: relative;
}
.salesmandailizhongxingPage .mu-list img.new{
  position: absolute;
  right: -8px;
  top: -8px;
}
.salesmandailizhongxingPage .mu-avatar-inner,.salesmandailizhongxingPage  .mu-tabs{
  width: 18px;
  height: 18px;
  background: red;
  color: #fff;
  font-size: 12px;
  border-radius: 50%;
  position: absolute;
  right: -5px;
  top: -8px;
}
.salesmandailizhongxingPage .mu-list .mu-item-right .fa-angle-right{
  font-size: 24px;
}
.salesmandailizhongxingPage .login-bg {
    width: 100%;
    height: 165px;
    position: relative;
    text-align: center;
    justify-content: center;
    background: url('/static/us-top-bg.png');
    /* background: url('/static/us-top-xn.png'); */
    background-size: 100% 100%;
}
.salesmandailizhongxingPage .login-bg .memberLv{
    margin-left: 100px;
    color: #fff;
    padding-top: 40px;
    text-align: left;
}
.salesmandailizhongxingPage .login-bg .memberLv .level{
  background: #000;
  padding: 3px 5px;
  height: 20px;
  line-height: 20px;
  border-radius: 15px;
}
.salesmandailizhongxingPage .login-bg .memberLv .level .fa-diamonds{
  color: yellow;
  margin-right: 5px;
}
.salesmandailizhongxingPage .login-bg .memberLv .nickName{
  text-overflow: ellipsis;
  float: left;
  overflow: hidden;
  max-width: 30%;
  margin-right: 5px;
  color: #fff;
  display: block;
  white-space: nowrap;
}
.salesmandailizhongxingPage .login-bg .inviteCode{
  margin-top: 5px;
  color: #fff;
  margin-left: 100px;
  text-align: left;
}
.salesmandailizhongxingPage .login-bg .inviteCode .copyBtn{
  background-color: rgba(200,200,200,0.3);
  color: #fff;
  padding: 3px 5px;
  border-radius: 10px;
}
.salesmandailizhongxingPage .demo-flat-button{
    position: absolute;
    border: 0;
    top: 10px;
    right: 10px;
    color: #fff;
    border: 1px solid #fff;
 }
.salesmandailizhongxingPage .mu-flat-button{
   min-width: 60px;
    height: 25px;
    line-height: 25px;
 } 
.salesmandailizhongxingPage .mu-flat-button .mu-flat-button-label{
  font-size: 12px;
}
 .salesmandailizhongxingPage .bouns{
  position: absolute;
  bottom: 0;
  width: 95%;
  left: 0;
  right: 0;
  margin: 0 auto;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 15px 15px 0 0;
  background: url('/static/uclist_bg.png');
  background-size: 100% 100%;
}
.salesmandailizhongxingPage .bouns p{
  font-size: 16px;
  color: #696969;
}
 .salesmandailizhongxingPage .login-bg img.touxiang{
  width: 60px;
  height: 60px;
  border-radius: 50%;
  position: absolute;
  left: 20px;
  top: 30px;
  z-index: 1;
}
.salesmandailizhongxingPage .bouns .grant,.salesmandailizhongxingPage .bouns .put{
  width: 50%;
  z-index: 1;
}

.salesmandailizhongxingPage .bouns .count{
  font-size: 16px;
  color: #ff4981;
}
.salesmandailizhongxingPage .bouns .text{
  font-size: 12px;
  color: #fff;
}

.salesmandailizhongxing .bottom-nav{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

</style>




// WEBPACK FOOTER //
// src/pages/salesman/salesmanindex.vue